export default "__VITE_ASSET__8e7570d2__"